// TOP LEVEL IMPORTS
import React from 'react';
import Alert from 'components/common/Alert'; // for js

const StripeErrors = stripeError => {
  if (stripeError && stripeError.length > 0) {
    return <Alert type="error" message={stripeError} className="mt1" banner />;
  }
  return null;
};

export default StripeErrors;



// WEBPACK FOOTER //
// ./src/routes/invoice-pay/PaymentFormArea/PaymentFormContainer/PaymentForm/StripeErrors/index.js